import { createRef } from 'react';
import { ColumnIdentifier, GridColumnConfig } from './types';
import { shortDateHandler } from '@utils';

const defaultConfig = (data: any) => ({
	filterParams: {
		values: data,
		debounceMs: 300,
		excelMode: 'windows',
	},
	cellRenderer: ({ value }: any) => {
		return !!value ? value : '-';
	},
});

const dateConfig = (data: any) => ({
	filterParams: {
		values: data,
		debounceMs: 300,
		excelMode: 'windows',
	},
	cellRenderer: ({ value }: { value: string }) => (value ? shortDateHandler(value) : '-'),
});

export const columnsConfig = {
	[ColumnIdentifier.ACCOUNT_ID]: defaultConfig,
	[ColumnIdentifier.CREATED]: dateConfig,
	[ColumnIdentifier.SITE]: defaultConfig,
	[ColumnIdentifier.MARKET]: defaultConfig,
	[ColumnIdentifier.PLAN]: defaultConfig,
	[ColumnIdentifier.OWNER]: defaultConfig,
	[ColumnIdentifier.COUNTRY]: defaultConfig,
	[ColumnIdentifier.SALES_REP]: defaultConfig,
	[ColumnIdentifier.ACCT_MGMT_REP]: defaultConfig,
	[ColumnIdentifier.PROVIDER]: defaultConfig,
	[ColumnIdentifier.PROMOTER]: defaultConfig,
	[ColumnIdentifier.STATUS]: defaultConfig,
};

export const columnsDefinition: GridColumnConfig[] = [
	{
		identifier: ColumnIdentifier.ACCOUNT_ID,
		ref: createRef(),
		options: {
			headerName: 'Account ID',
			field: 'AccountName',
			width: 220,
		},
		actions: {
			ref: createRef(),
			filter: false,
			enableRowGroup: false,
		},
	},
	{
		identifier: ColumnIdentifier.CREATED,
		ref: createRef(),
		options: {
			headerName: 'Created',
			field: 'Created',
			width: 110,
			filter: false,
			enableRowGroup: false,
		},
	},
	{
		identifier: ColumnIdentifier.SITE,
		ref: createRef(),
		options: {
			headerName: 'Site',
			field: 'Site',
			width: 90,
			filter: false,
			enableRowGroup: false,
		},
	},
	{
		identifier: ColumnIdentifier.MARKET,
		ref: createRef(),
		options: {
			headerName: 'Market',
			field: 'Market',
			width: 90,
			filter: false,
			enableRowGroup: false,
		},
	},
	{
		identifier: ColumnIdentifier.PLAN,
		ref: createRef(),
		options: {
			headerName: 'Plan',
			field: 'Plan',
			width: 200,
			filter: false,
			enableRowGroup: false,
		},
	},
	{
		identifier: ColumnIdentifier.OWNER,
		ref: createRef(),
		options: {
			headerName: 'Owner',
			field: 'Owner',
			width: 320,
			filter: false,
			enableRowGroup: false,
		},
	},
	{
		identifier: ColumnIdentifier.COUNTRY,
		ref: createRef(),
		options: {
			headerName: 'Country',
			field: 'Country',
			width: 130,
			filter: false,
			enableRowGroup: false,
		},
	},
	{
		identifier: ColumnIdentifier.SALES_REP,
		ref: createRef(),
		options: {
			headerName: 'Sales Rep',
			field: 'SalesRep',
			width: 160,
			filter: false,
			enableRowGroup: false,
		},
	},
	{
		identifier: ColumnIdentifier.ACCT_MGMT_REP,
		ref: createRef(),
		options: {
			headerName: 'CSM Rep',
			field: 'AcctMgmtRep',
			width: 160,
			filter: false,
			enableRowGroup: false,
		},
	},
	{
		identifier: ColumnIdentifier.PROVIDER,
		ref: createRef(),
		options: {
			headerName: 'Provider',
			field: 'Provider',
			width: 95,
			filter: false,
			enableRowGroup: false,
		},
	},
	{
		identifier: ColumnIdentifier.PROMOTER,
		ref: createRef(),
		options: {
			headerName: 'Promoter',
			field: 'Promoter',
			width: 80,
			filter: false,
			enableRowGroup: false,
		},
	},
	{
		identifier: ColumnIdentifier.STATUS,
		ref: createRef(),
		options: {
			headerName: 'Status',
			field: 'Status',
			width: 120,
			filter: false,
			enableRowGroup: false,
		},
	},
];
